import {ContractorDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'DELETE_CONTRACTOR';

export async function deleteContractor(
    userData: Record<string, string>,
    contractorId: number
) {
    try {
        const deleteContractorResult = await ContractorDao.deleteContractor(userData.userToken, contractorId);

        return deleteContractorResult;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression.',
            error: error
        });
    }
}
